import React from 'react';
import { MuiPopup } from '../molecules/popupComponent';
import { YellowWarningIcon } from '../../assets/images';
import { MuiStack } from '../atoms/stackComponent';
import { Typography } from '@mui/material';
import { t } from 'i18next';
import { MuiButton } from '../atoms/buttonComponent';
import { MuiLoaderButton } from '../atoms/loaderButton';
import { useAppSelector } from '../../store/hooks';
var AmcContractPopup = function (props) {
    var isOpen = props.isOpen, onClosePopup = props.onClosePopup, onClickNoBtn = props.onClickNoBtn, onClickYesBtn = props.onClickYesBtn, amcServiceTypeDetails = props.amcServiceTypeDetails;
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: isOpen,
        closeIcon: true,
        backdropEnable: true,
        onClose: function () {
            onClosePopup(false);
        },
        padding: "15px 0px 0px 15px",
        headerIcon: YellowWarningIcon
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        padding: 0,
        margin: 0
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1"
    }, t("".concat(amcServiceTypeDetails === null || amcServiceTypeDetails === void 0 ? void 0 : amcServiceTypeDetails.DisplayName, " available"))), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: "#6A7682",
        marginTop: 2
    }, t("Do you want to go with ".concat(amcServiceTypeDetails === null || amcServiceTypeDetails === void 0 ? void 0 : amcServiceTypeDetails.DisplayName, "?"))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: {
            xs: 'column',
            sm: 'row-reverse'
        },
        spacing: 2,
        paddingTop: 3,
        minWidth: '100%'
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "yes-btn",
        size: "medium",
        fullWidth: true,
        name: t("Yes"),
        variant: "contained",
        onClick: onClickYesBtn
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "no-btn",
        size: "medium",
        fullWidth: true,
        name: t("No"),
        variant: "outlined",
        style: {
            border: '1px solid #DEE4EB',
            color: '#6A7682'
        },
        onClick: onClickNoBtn
    }))));
};
export default AmcContractPopup;
